module.exports = __webpack_public_path__ + "static/media/rules-and-stuff.dea35e67.svg";